import { render, staticRenderFns } from "./StoreCommentsSettings.vue?vue&type=template&id=021d9310&"
import script from "./StoreCommentsSettings.vue?vue&type=script&lang=js&"
export * from "./StoreCommentsSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports